export default {
  shape:
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.571 16a.582.582 0 0 1-.352-.119L8 12.713 3.78 15.88a.581.581 0 0 1-.706-.002.65.65 0 0 1-.22-.703l1.573-5.182L.247 6.77a.65.65 0 0 1-.217-.705.59.59 0 0 1 .57-.418h5.192L7.427.433A.607.607 0 0 1 8 0c.26 0 .491.174.573.433l1.635 5.214H15.4c.26.002.49.16.57.418a.65.65 0 0 1-.216.705l-4.181 3.224 1.573 5.182a.65.65 0 0 1-.22.703.584.584 0 0 1-.355.121Z" fill="#FF9F0A"/>',
  viewBox: [0, 0, 16, 17],
};
